<template>
  <div class="quantidade-selector">
    <div class="quantidade">
      <div class="less btn " @click="decrementValue">
      </div>
      <div class="input">
        <input type="text" placeholder="0" :max="max" :min="min" v-model="myvalue">
      </div>
      <div class="more btn" @click="incrementValue">
      </div>
    </div>
    <div class='unidade'>
        {{ unidade }}
    </div>
  </div>
</template>


<script>

export default {
        props:{
            increment:{
                default:1
            },
            min:{
                default:0
            },
            max:{
                default:Infinity
            },
            value:{
                default:0
            },
            unidade:{
                default:'unidade'
            }
        },

        data(){
            return { myvalue: 0 }
        },

        created(){
            this.myvalue = this.value
        },

        watch:{
            "$props.value":function(){
                this.myvalue = this.value
            },
            myvalue:function(val){
                //pego quantos incrementos eu tenho
                this.$emit('input',val)
                this.$emit('change',val)
            }
        },

       methods:{
           incrementValue:function(){
               let currentValue = Number(this.myvalue) + Number(this.increment)
               if(currentValue <= this.max){
                    this.myvalue = currentValue
                }
           },
           decrementValue:function(){
                let currentValue = Number(this.myvalue) - Number(this.increment)
                if(currentValue >= this.min){
                    this.myvalue = currentValue
                }
           },
       }
}

</script>

<style lang="stylus">

.quantidade-selector{

    display:flex;
    flex-direction: column
    justify-content:center;  

    .quantidade{  
        display:flex;
        justify-content: center;
        margin-bottom:10px;

        .btn{
            width: 45px;
            height: 48px;
            background: var(--cor-principal)
            color:white;
            position:relative;
            cursor:pointer;
            
            &:after{
                content:'+'
                color:black;
                font-weight: bold;
                font-size: 18px;
                line-height: 38px;
            }
        }
        .input{
             height: 48px;
             background: rgba(white,0.7);
             max-width: 65px;
             input{
                 width:100%;
                 height:100%;
                 border:none;
                 text-align:center;
                 font-size: 22px;
                 line-height: 25px;
                 color: #000000;
                 opacity: 1;
                 font-weight: bold;
                 &::placeholder{
                     color: gray;
                 }
             }
          
        }
        .less{
            &:after{
            content:'–'
            }
            border-radius: 8px 0px 0px 8px
            
        }
        .more{
            border-radius: 0px 8px 8px 0px
        }

    }

    .unidade{
        font-size: 18px;
        font-weight: 800;
        line-height: 18px;
        text-align: center;
    }
}

</style>
